import { LookupModelDto } from '@treasury/api/channel';

export const achFrequencies: LookupModelDto[] = [
    {
        id: 2,
        value: 'Weekly',
        key: 'Weekly',
        updatedDate: '',
    },
    {
        id: 3,
        value: 'Every Two Weeks',
        key: 'EveryTwoWeeks',
        updatedDate: '',
    },
    { id: 4, value: 'Twice a Month', key: 'TwiceAMonth', updatedDate: '' },
    { id: 5, value: 'Monthly', key: 'Monthly', updatedDate: '' },
    { id: 6, value: 'Quarterly', key: 'Quarterly', updatedDate: '' },
    { id: 7, value: 'Every Six Months', key: 'EverySixMonths', updatedDate: '' },
    { id: 8, value: 'Annually', key: 'Yearly', updatedDate: '' },
];
